<template>
  <div class="battle-history-page pk-account-panel">
    <section class="history-hero">
      <button class="back-btn" @click="$router.push({ path: '/zh/battles' })">返回</button>
      <span>箱子战斗</span>
      <h1>对战历史</h1>
      <p>展示全部对战和我的对战记录，房间、玩家和结果以历史页面展示为准。</p>
    </section>

    <section class="history-tabs">
      <button :class="{ active: activeName === 'one' }" @click="switchTab('one')">所有记录</button>
      <button :class="{ active: activeName === 'two' }" @click="switchTab('two')">我的记录</button>
    </section>

    <section class="battle-list">
      <article v-for="item in activeList" :key="item.id || item.battle_id" class="battle-card" @click="goLuckyRoom(item)">
        <div class="battle-meta">
          <div>
            <span>{{ statusText(item.status) }}</span>
            <strong>{{ moneyText(item.price) }} <i></i></strong>
          </div>
          <em>房间 {{ item.room_num || item.id || item.battle_id }}</em>
        </div>
        <div class="player-row">
          <div v-for="player in playerSlots(item)" :key="player.slotKey" class="player-avatar" :class="{ empty: player.empty }">
            <img :src="player.img || defaultAvatar" alt="" @error="setImageFallback($event, defaultAvatar)" />
          </div>
        </div>
        <div class="box-row">
          <div v-for="box in boxPreview(item.boxInfo)" :key="box.key" class="box-item">
            <img :src="box.img || defaultBox" alt="" @error="setImageFallback($event, defaultBox)" />
            <span>x{{ box.num }}</span>
          </div>
        </div>
        <div class="battle-foot">
          <span>{{ item.create_time || item.time }}</span>
          <button>观看</button>
        </div>
      </article>
    </section>

    <div v-if="!activeList.length" class="empty-card">暂无对战记录。</div>

    <el-pagination
      v-if="activeTotal > activePageSize"
      class="history-page-nav"
      background
      layout="prev, pager, next"
      :total="activeTotal"
      :page-size="activePageSize"
      @current-change="currentChange"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "one",
      totalSize: 0,
      page: 1,
      pageSize: 24,
      tableData: [],
      totalSize1: 0,
      page1: 1,
      pageSize1: 10,
      tableData1: [],
      defaultAvatar: require("../assets/img/jiapeople.png"),
      defaultBox: require("../assets/hotpizza/hp-case-orange.png"),
    };
  },
  computed: {
    activeList() {
      return this.activeName === "one" ? this.tableData : this.tableData1;
    },
    activeTotal() {
      return this.activeName === "one" ? this.totalSize : this.totalSize1;
    },
    activePageSize() {
      return this.activeName === "one" ? this.pageSize : this.pageSize1;
    },
  },
  mounted() {
    this.getHist(this.page);
  },
  methods: {
    switchTab(tab) {
      if (tab === "two" && !this.isLoggedIn()) {
        this.openLogin();
        return;
      }
      this.activeName = tab;
      if (tab === "one") {
        this.getHist(this.page);
      } else {
        this.getMyHist(this.page1);
      }
    },
    normalizeBattleList(result) {
      for (let i = 0; i < result.length; i++) {
        if (typeof result[i].boxInfo === "string") {
          result[i].boxInfo = JSON.parse(result[i].boxInfo);
        }
        result[i].price = 0;
        for (let j = 0; j < result[i].boxInfo.length; j++) {
          result[i].price += Number(result[i].boxInfo[j].price);
        }
        result[i].price = result[i].price.toFixed(2);
      }
      return result;
    },
    getHist(page) {
      this.page = page;
      this.$axios.post("/index/Battle/battleList", this.$qs.stringify({ page, pageSize: this.pageSize })).then((res) => {
        if (res.data.status == "1" && res.data.data != null) {
          this.totalSize = res.data.data.total;
          this.tableData = this.normalizeBattleList(res.data.data.battleList);
        }
      });
    },
    getMyHist(page) {
      this.page1 = page;
      this.$axios.post("index/Battle/battleHistory", this.$qs.stringify({ page, pageSize: this.pageSize1 })).then((res) => {
        if (res.data.status == "1" && res.data.data != null) {
          this.totalSize1 = res.data.data.total;
          this.tableData1 = this.normalizeBattleList(res.data.data.list);
        }
      });
    },
    currentChange(val) {
      if (this.activeName === "two" && !this.isLoggedIn()) {
        this.openLogin();
        return;
      }
      if (this.activeName === "one") {
        this.getHist(val);
      } else {
        this.getMyHist(val);
      }
    },
    playerSlots(item) {
      const players = JSON.parse(JSON.stringify(item.player_info || []));
      const mode = Number(item.mode || players.length || 2);
      for (let i = players.length; i < mode; i++) {
        players.push({ img: this.defaultAvatar, empty: true, slotKey: `empty-${i}` });
      }
      for (let i = 0; i < players.length; i++) {
        players[i].slotKey = players[i].slotKey || `${players[i].id || "player"}-${i}`;
        players[i].img = this.stableImage(players[i].img, this.defaultAvatar);
      }
      return players;
    },
    boxPreview(boxInfo) {
      const boxes = boxInfo || [];
      const map = {};
      for (let i = 0; i < boxes.length; i++) {
        const key = boxes[i].id || boxes[i].box_id || boxes[i].name || i;
        if (!map[key]) {
          map[key] = { key, img: this.stableImage(boxes[i].img_main || boxes[i].img, this.defaultBox), num: 0 };
        }
        map[key].num += 1;
      }
      return Object.keys(map).map((key) => map[key]).slice(0, 5);
    },
    statusText(status) {
      return { 1: "等待中", 2: "进行中", 3: "已结束" }[status] || "记录";
    },
    goLuckyRoom(item) {
      this.$router.push({ path: "/LuckyRoom", query: { id: item.id || item.battle_id } });
    },
    moneyText(value) {
      return Number(value || 0).toFixed(2);
    },
    stableImage(value, fallback) {
      if (!value) return fallback;
      if (value.indexOf("http://") === 0) return fallback;
      if (value.indexOf("csgoapi.akaifa998.icu") !== -1) return fallback;
      return value;
    },
    setImageFallback(event, fallback) {
      event.target.src = fallback;
    },
    isLoggedIn() {
      return Boolean(this.$store.state.token || localStorage.getItem("token"));
    },
    openLogin() {
      this.$store.commit("getLogin", true);
    },
  },
};
</script>

<style lang="less" scoped>
.battle-history-page {
  min-height: calc(100vh - 198px);
  padding: 34px 34px 90px;
  color: #f5f7ff;
  background:
    radial-gradient(circle at 48% 0, rgba(255, 138, 31, 0.16), transparent 30%),
    radial-gradient(circle at 84% 28%, rgba(143, 103, 255, 0.14), transparent 28%),
    linear-gradient(180deg, #1f212d 0%, #171923 100%);
}

button {
  font-family: inherit;
  cursor: pointer;
}

.history-hero,
.history-tabs,
.battle-list,
.empty-card,
.history-page-nav {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
}

.history-hero {
  min-height: 260px;
  padding: 46px 54px;
  position: relative;
  overflow: hidden;
  border-radius: 18px;
  background:
    linear-gradient(130deg, rgba(41, 43, 58, 0.96), rgba(24, 26, 36, 0.98)),
    url("../assets/new/task_bg.png") center / cover;
  border: 1px solid rgba(255, 132, 31, 0.28);
  box-shadow: 0 26px 80px rgba(0, 0, 0, 0.34);
}

.history-hero::after {
  content: "";
  width: 780px;
  height: 280px;
  position: absolute;
  right: -170px;
  bottom: -160px;
  border-radius: 50%;
  background: radial-gradient(ellipse, rgba(255, 138, 0, 0.38), transparent 66%);
}

.back-btn {
  height: 44px;
  padding: 0 20px;
  position: absolute;
  right: 22px;
  top: 22px;
  z-index: 2;
  color: #f4f6ff;
  background: #303342;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 7px;
  font-weight: 1000;
}

.history-hero span {
  position: relative;
  z-index: 1;
  color: #ff8a1f;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.18em;
}

.history-hero h1 {
  position: relative;
  z-index: 1;
  margin: 12px 0 14px;
  font-size: 64px;
  line-height: 0.98;
  font-weight: 1000;
}

.history-hero p {
  position: relative;
  z-index: 1;
  max-width: 760px;
  color: #aeb6c8;
  font-size: 17px;
  line-height: 1.8;
  font-weight: 800;
}

.history-tabs {
  margin-top: 20px;
  padding: 14px;
  display: flex;
  gap: 10px;
  border-radius: 12px;
  background: #242735;
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.history-tabs button {
  height: 42px;
  padding: 0 20px;
  color: #f4f6ff;
  background: #303342;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 7px;
  font-weight: 1000;
}

.history-tabs button.active {
  color: #151620;
  background: linear-gradient(180deg, #ffd53b, #ff8300);
  border: 0;
}

.battle-list {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
  gap: 16px;
}

.battle-card {
  min-height: 260px;
  padding: 18px;
  border-radius: 14px;
  background: linear-gradient(180deg, #2b2e3d, #242735);
  border: 1px solid rgba(255, 138, 0, 0.2);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.035), 0 16px 44px rgba(0, 0, 0, 0.24);
  cursor: pointer;
}

.battle-meta,
.battle-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}

.battle-meta span {
  color: #12d9e8;
  font-size: 12px;
  font-weight: 1000;
}

.battle-meta strong {
  margin-top: 6px;
  display: flex;
  align-items: center;
  gap: 6px;
  color: #ffd764;
  font-size: 24px;
  font-weight: 1000;
}

.battle-meta i,
.box-item span::after {
  width: 17px;
  height: 17px;
  display: inline-block;
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
}

.battle-meta em {
  color: #8f98ab;
  font-size: 13px;
  font-style: normal;
  font-weight: 900;
}

.player-row {
  margin-top: 20px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.player-avatar {
  width: 54px;
  height: 54px;
  padding: 3px;
  border-radius: 50%;
  background: linear-gradient(180deg, #ffd53b, #ff8300);
}

.player-avatar.empty {
  background: #3a3d4c;
  border: 1px dashed rgba(255, 255, 255, 0.18);
}

.player-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.box-row {
  margin-top: 18px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
}

.box-item {
  min-height: 86px;
  position: relative;
  display: grid;
  place-items: center;
  border-radius: 8px;
  background: radial-gradient(circle at 50% 40%, rgba(129, 73, 255, 0.28), transparent 62%), #202330;
  border: 1px solid rgba(255, 255, 255, 0.055);
}

.box-item img {
  max-width: 84px;
  max-height: 58px;
  object-fit: contain;
  filter: drop-shadow(0 12px 16px rgba(0, 0, 0, 0.42));
}

.box-item span {
  position: absolute;
  left: 7px;
  bottom: 6px;
  color: #ffd764;
  font-size: 12px;
  font-weight: 1000;
}

.battle-foot {
  margin-top: 18px;
}

.battle-foot span {
  color: #9aa3b8;
  font-size: 13px;
  font-weight: 900;
}

.battle-foot button {
  height: 38px;
  padding: 0 18px;
  color: #151620;
  background: linear-gradient(180deg, #ffd53b, #ff8300);
  border: 0;
  border-radius: 7px;
  font-weight: 1000;
}

.empty-card {
  margin-top: 18px;
  padding: 34px 18px;
  color: #929bad;
  text-align: center;
  background: #242735;
  border: 1px solid rgba(255, 255, 255, 0.055);
  border-radius: 10px;
  font-size: 14px;
  font-weight: 800;
}

.history-page-nav {
  margin-top: 18px;
  text-align: right;
}

.history-page-nav /deep/ .el-pager li:not(.disabled).active {
  color: #151620;
  background: #ffae1d;
}

.history-page-nav /deep/ .el-pagination.is-background .btn-next,
.history-page-nav /deep/ .el-pagination.is-background .btn-prev,
.history-page-nav /deep/ .el-pagination.is-background .el-pager li {
  color: #aab3c6;
  background: #242735;
}

@media screen and (max-width: 980px) {
  .battle-history-page {
    padding: 20px 12px 64px;
  }

  .history-hero {
    padding: 72px 24px 34px;
  }

  .history-hero h1 {
    font-size: 46px;
  }

  .battle-list {
    grid-template-columns: 1fr;
  }
}
</style>

<style lang="less">
body:has(.battle-history-page) .battle-history-page.pk-account-panel {
  min-height: calc(100vh - 199px) !important;
  padding: 22px 24px 96px !important;
  background:
    radial-gradient(circle at 50% 0, rgba(253, 107, 1, 0.08), transparent 360px),
    #191b26 !important;
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel .history-hero,
body:has(.battle-history-page) .battle-history-page.pk-account-panel .history-tabs,
body:has(.battle-history-page) .battle-history-page.pk-account-panel .battle-list,
body:has(.battle-history-page) .battle-history-page.pk-account-panel .empty-card {
  width: 100% !important;
  max-width: none !important;
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel .history-hero {
  min-height: 226px !important;
  border-radius: 8px !important;
  background:
    radial-gradient(circle at 12% 45%, rgba(255, 132, 31, 0.15), transparent 260px),
    #20222f !important;
  border-color: #2b2d3c !important;
  box-shadow: none !important;
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel .battle-list {
  grid-template-columns: repeat(auto-fill, minmax(394px, 1fr)) !important;
  gap: 8px !important;
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel .battle-card {
  height: 208px !important;
  border-radius: 8px !important;
  border-color: rgba(236, 216, 184, 0.08) !important;
  background: #20222f !important;
  box-shadow: none !important;
}
</style>

<style lang="less">
.battle-history-page.pk-account-panel {
  padding: 32px 28px 96px !important;
}

.battle-history-page.pk-account-panel .history-hero,
.battle-history-page.pk-account-panel .history-tabs,
.battle-history-page.pk-account-panel .battle-list,
.battle-history-page.pk-account-panel .empty-card,
.battle-history-page.pk-account-panel .history-page-nav {
  width: calc(100% - 24px) !important;
  max-width: 1540px !important;
}

.battle-history-page.pk-account-panel .history-hero {
  min-height: 304px !important;
  border-color: rgba(255, 132, 31, 0.38) !important;
  box-shadow:
    0 28px 90px rgba(0, 0, 0, 0.38),
    inset 0 1px 0 rgba(255, 224, 170, 0.08) !important;
}

.battle-history-page.pk-account-panel .battle-list {
  grid-template-columns: repeat(auto-fit, minmax(430px, 1fr)) !important;
  gap: 18px !important;
}

.battle-history-page.pk-account-panel .battle-card {
  min-height: 294px !important;
  border-color: rgba(255, 138, 0, 0.28) !important;
}

.battle-history-page.pk-account-panel .box-item {
  min-height: 104px !important;
}

.battle-history-page.pk-account-panel .box-item img {
  max-width: 104px !important;
  max-height: 72px !important;
}

@media screen and (max-width: 980px) {
  .battle-history-page.pk-account-panel {
    padding: 18px 12px 58px !important;
  }

  .battle-history-page.pk-account-panel .history-hero,
  .battle-history-page.pk-account-panel .history-tabs,
  .battle-history-page.pk-account-panel .battle-list,
  .battle-history-page.pk-account-panel .empty-card,
  .battle-history-page.pk-account-panel .history-page-nav {
    width: 100% !important;
  }

  .battle-history-page.pk-account-panel .battle-list {
    grid-template-columns: 1fr !important;
  }
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel {
  min-height: calc(100vh - 198px) !important;
  padding: 24px 24px 90px !important;
  background:
    radial-gradient(80% 34% at 50% 0, rgba(236, 216, 184, 0.08), transparent 62%),
    linear-gradient(180deg, #1c1d29 0%, #171923 100%) !important;
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel .history-hero,
body:has(.battle-history-page) .battle-history-page.pk-account-panel .history-tabs,
body:has(.battle-history-page) .battle-history-page.pk-account-panel .battle-list,
body:has(.battle-history-page) .battle-history-page.pk-account-panel .empty-card,
body:has(.battle-history-page) .battle-history-page.pk-account-panel .history-page-nav {
  width: min(1540px, calc(100% - 16px)) !important;
  max-width: 1540px !important;
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel .history-hero {
  min-height: 82px !important;
  padding: 0 20px 0 24px !important;
  display: flex !important;
  align-items: center !important;
  gap: 18px !important;
  border: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel .history-hero::after {
  content: none !important;
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel .history-hero span {
  order: 1 !important;
  color: #ecd8b8 !important;
  font-size: 12px !important;
  line-height: 100% !important;
  font-weight: 700 !important;
  letter-spacing: 0 !important;
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel .history-hero h1 {
  order: 2 !important;
  margin: 0 !important;
  color: #f5f7fc !important;
  font-size: 24px !important;
  line-height: 100% !important;
  font-weight: 700 !important;
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel .history-hero p {
  order: 3 !important;
  max-width: 620px !important;
  margin: 0 !important;
  color: rgba(240, 248, 255, 0.55) !important;
  font-size: 13px !important;
  line-height: 18px !important;
  font-weight: 500 !important;
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel .back-btn {
  order: 4 !important;
  position: static !important;
  height: 44px !important;
  margin-left: auto !important;
  padding: 0 20px !important;
  color: #ecd8b8 !important;
  background: transparent !important;
  border: 1px solid #ecd8b8 !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  font-weight: 700 !important;
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel .history-tabs {
  height: 52px !important;
  margin-top: 0 !important;
  padding: 6px !important;
  display: inline-flex !important;
  gap: 6px !important;
  background: #21232f !important;
  border: 1px solid rgba(236, 216, 184, 0.08) !important;
  border-radius: 10px !important;
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel .history-tabs button {
  height: 38px !important;
  padding: 0 20px !important;
  color: rgba(240, 248, 255, 0.6) !important;
  background: transparent !important;
  border: 0 !important;
  border-radius: 8px !important;
  font-size: 13px !important;
  font-weight: 700 !important;
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel .history-tabs button.active {
  color: #ecd8b8 !important;
  background: #2a2d3a !important;
  box-shadow: inset 0 0 0 1px rgba(236, 216, 184, 0.18) !important;
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel .battle-list {
  margin-top: 14px !important;
  display: grid !important;
  grid-template-columns: repeat(auto-fill, minmax(394px, 1fr)) !important;
  gap: 10px !important;
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel .battle-card {
  min-height: 157px !important;
  padding: 0 !important;
  overflow: hidden !important;
  border: 0 !important;
  border-radius: 10px !important;
  background: #282a35 !important;
  box-shadow: none !important;
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel .battle-meta {
  height: 66px !important;
  padding: 14px 18px 0 !important;
  background:
    radial-gradient(100% 50% at 50% 0, rgba(236, 216, 184, 0.1), rgba(39, 42, 54, 0)),
    linear-gradient(180deg, #21232f, #282a35) !important;
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel .battle-meta span,
body:has(.battle-history-page) .battle-history-page.pk-account-panel .battle-meta em {
  color: rgba(240, 248, 255, 0.72) !important;
  font-size: 12px !important;
  font-weight: 700 !important;
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel .battle-meta strong {
  margin-top: 8px !important;
  color: #edb145 !important;
  font-size: 18px !important;
  line-height: 18px !important;
  font-weight: 700 !important;
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel .battle-meta i {
  width: 14px !important;
  height: 14px !important;
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel .player-row {
  position: absolute !important;
  left: 18px !important;
  top: 38px !important;
  margin: 0 !important;
  gap: 3px !important;
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel .player-avatar,
body:has(.battle-history-page) .battle-history-page.pk-account-panel .player-avatar img {
  width: 16px !important;
  height: 16px !important;
  padding: 0 !important;
  border-radius: 16px !important;
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel .player-avatar.empty {
  opacity: 0.5 !important;
  background: #3b3e4d !important;
  border: 0 !important;
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel .box-row {
  height: 70px !important;
  margin: 0 !important;
  display: grid !important;
  grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
  gap: 0 !important;
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel .box-item {
  min-height: 70px !important;
  border: 0 !important;
  border-right: 1px solid rgba(236, 216, 184, 0.12) !important;
  border-bottom: 1px solid #ecd8b8 !important;
  border-radius: 0 !important;
  background: linear-gradient(180deg, rgba(40, 42, 53, 0), rgba(236, 216, 184, 0.2)), #282a35 !important;
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel .box-item img {
  max-width: 92% !important;
  max-height: 58px !important;
  filter: drop-shadow(0 10px 12px rgba(0, 0, 0, 0.42)) !important;
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel .box-item span {
  left: 6px !important;
  top: 5px !important;
  bottom: auto !important;
  color: #ecd8b8 !important;
  font-size: 10px !important;
  line-height: 100% !important;
  font-weight: 700 !important;
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel .battle-foot {
  height: 21px !important;
  margin: 0 !important;
  padding: 0 18px !important;
  display: flex !important;
  align-items: center !important;
  background: #282a35 !important;
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel .battle-foot span {
  color: rgba(240, 248, 255, 0.38) !important;
  font-size: 11px !important;
  font-weight: 500 !important;
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel .battle-foot button {
  width: 92px !important;
  height: 32px !important;
  transform: translateY(-50px) !important;
  color: #ecd8b8 !important;
  background: transparent !important;
  border: 1px solid #ecd8b8 !important;
  border-radius: 6px !important;
  font-size: 14px !important;
  font-weight: 700 !important;
}

body:has(.battle-history-page) .battle-history-page.pk-account-panel .empty-card {
  margin-top: 14px !important;
  color: rgba(240, 248, 255, 0.45) !important;
  background: #21232f !important;
  border: 1px solid rgba(236, 216, 184, 0.08) !important;
  border-radius: 10px !important;
}
</style>
